import { j as m } from "./jsx-runtime-3tyXYecC.mjs";
import { cloneElement as i } from "react";
function d({ items: t, backgroundColor: n, borderColor: o }) {
  function r(e) {
    return e.map((s, a) => i(s, { backgroundColor: n, borderColor: o, borderPlacement: a === 0 ? "none" : "top" }));
  }
  return /* @__PURE__ */ m.jsx("div", { "data-fabric-component": "SlatGroup", children: r(t) });
}
export {
  d as S
};
//# sourceMappingURL=slat-group-Cduur4t6.mjs.map
